import React, { useEffect, useRef, useState } from "react";
import "./Post.css"
import axiosConfig from "../../Service/axiosConfig"
import { Actions } from "./Actions";
import { Helmet } from "react-helmet";
import { AiOutlineComment } from "react-icons/ai";
import { Like } from "../Like";
import { Shortlist } from "../ShortList";
import { LikesPopup } from "./LikesPop";
import { BiSend } from "react-icons/bi";
import { hasRelevantRole } from "../../Utils/RoleCheckService";
import { CommentsList } from "../Comments/CommentsList";
import { Modal } from "react-bootstrap";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { PostFooter } from "./PostFooter";

const PostPop = (props) => {
    const { item } = props;
    function handleHideEvent() {
        props.handleHideEvent();
    }
    return (
        <>
            <Helmet>
                <meta property="og:image" content={item.image} />
                <meta property="og:title" content={item.profile.full_name} />
                <meta property="og:description" content={`${item.profile.hcc_id} - ${item.profile.designation}`} />
            </Helmet>
            <div className="post-modal-view">
                <div className="pm-img-container">
                    <div className="imgholder">
                        <img src={item.image} className="post-modal-img" alt={item?.profile?.full_name} />
                    </div>
                    <div className="show-only-mobile">
                        <PostFooter item={item} />
                        <div className="hide-mobile">
                            <CommentsList item={item} />
                        </div>
                    </div>
                </div>
                <div className="pm-content-container">
                    <div className="pdpop-header">
                        <div className="pdpop-ls">
                            <div className="pdpop-ls-container">
                                <img src={item && item.profile.profile_pic ? item.profile.profile_pic : require("../Post/images/male.jpg")} className="post-dp" width="40" alt={item.profile?.full_name} />
                                <div className="pdpop-titles">
                                    <a href={`/profile/${item.profile.hcc_id}`} style={{ textDecoration: 'none', color: 'rgb(33 37 41)' }}><p style={{ fontWeight: 600, fontSize: '14px' }}>{item.profile.full_name}</p></a>
                                    <p><strong>{item.profile.hcc_id}</strong> - {item.profile.designation}</p>
                                </div>
                            </div>
                        </div>
                        <div className="pdpop-rs">
                            <Actions item={item} handleHideEvent={handleHideEvent} />
                        </div>
                    </div>
                    <hr className="pdpop-hr" />
                    <div className="hide-mobile">
                        <CommentsList item={item} />
                    </div>
                </div>
            </div>
        </>
    )
}
export { PostPop };